import type { Note } from '@payaca/types/notesTypes';
import type { User } from '@payaca/types/userTypes';

export const getNoteTitle = (note?: Note, createdByUser?: Pick<User, 'id'>) => {
  if (note) {
    if (createdByUser) {
      return note?.dealId ? 'Project Note ' : 'Event Note ';
    } else {
      return note?.isCreatedBySystem ? 'System Note' : 'Note';
    }
  }
};
